<h1 class="text-center">
	{{ isUpgradeMode ? 'Upgrade' : 'Manage' }}
	Your Plan
</h1>

<content>
	<bp-subscription-plan-charge-period-switcher
		[annualDiscount]="maxAnnualDiscount"
		[(selectedChargePeriod)]="selectedChargePeriod"
		(selectedChargePeriodChange)="selectedChargePeriodChange.emit($event)"
	></bp-subscription-plan-charge-period-switcher>

	<div class="subscription-plans-overview-cards-container bp-thin-scrollbar">
		<bp-subscription-plans-overview-cards
			class="bp-thin-scrollbar"
			[subscriptionPlans]="subscriptionPlans"
			[currentSubscriptionPlan]="currentSubscriptionPlan"
			[chargePeriod]="selectedChargePeriod"
			[currency]="selectedCurrency"
		>
			<ng-template let-subscriptionPlan>
				<ng-container *ngIf="castToSubscription(subscriptionPlan) as subscriptionPlan">
					<div
						*ngIf="currentSubscriptionPlan!.id === subscriptionPlan.id; else nonCurrentSubscriptionTpl"
						class="flex-column-align-items-center"
					>
						<h2 class="text-primary m-0 text-center font-weight-bold">
							<div>Your current plan</div>
							<div *ngIf="currentSubscriptionPlan!.hasFlatPrice">
								billed {{ currentMerchantSubscription!.chargePeriod.displayName | lowercase }}
							</div>
						</h2>

						<button
							*ngIf="currentSubscriptionPlan!.hasFlatPrice"
							class="link interactive use-current-color"
							(click)="switchToOppositeChargePeriod(subscriptionPlan)"
						>
							switch to {{ oppositeChargePeriodToCurrent }}
						</button>
					</div>

					<ng-template #nonCurrentSubscriptionTpl>
						<button
							*ngIf="subscriptionPlan.isEnterprise; else changeSubscriptionButtonTpl"
							type="button"
							class="bp-round-button w-100"
							color="primary"
							mat-flat-button
							bpGoogleTagOnClick="subscription_management_pricing_contact_us_click"
							bpCalendlyBookDemo="bdm"
						>
							Let's talk!
						</button>

						<ng-template #changeSubscriptionButtonTpl>
							<button
								type="button"
								class="bp-round-button w-100"
								color="primary"
								mat-flat-button
								(click)="changeSubscriptionPlan(subscriptionPlan)"
							>
								{{ subscriptionPlanActionLabelMap.get(subscriptionPlan) }}
							</button>
						</ng-template>
					</ng-template>
				</ng-container>
			</ng-template>
		</bp-subscription-plans-overview-cards>
	</div>
</content>
